export const SUBSCRIBE = "SUBSCRIBE";
export const UNSUBSCRIBE = "UNSUBSCRIBE";
export const SELECT_PAIR = "SELECT_PAIR";
export const FETCH_DATA_RESPONSE = "FETCH_DATA_RESPONSE";
export const STOP_STREAM = "STOP_STREAM";
export const FETCH_START = "FETCH_START";
export const FETCH_END = "FETCH_END";
